import React from 'react';
import type {PropsWithChildren} from 'react';

export class ErrorBoundary extends React.Component<PropsWithChildren> {
    state = {
        hasError: false,
    };

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error(error, info);
    }

    render() {
        const {hasError} = this.state;
        const {children} = this.props;

        if (hasError) {
            // TODO global error page
            return <div>Unknown error happened</div>;
        }

        return children;
    }
}
